import { authedJson } from './client';
import { API_ROUTES } from '../../../shared/api';
import { tzOffsetMinutes } from '../config';
import type {
  BookProgress,
  CardResult,
  DueDeck,
  LearnerStats,
  RecordReviewSessionResponse,
  RecordSessionResponse,
  SectionProgress,
} from '../../../shared/types';

type Auth = { getToken: () => string | null; doRefresh: () => Promise<boolean> };

export const progressApi = {
  stats: ({ getToken, doRefresh }: Auth) =>
    authedJson<LearnerStats>(
      `${API_ROUTES.stats}?tzOffsetMinutes=${tzOffsetMinutes()}`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),

  book: (bookId: string, { getToken, doRefresh }: Auth) =>
    authedJson<BookProgress>(API_ROUTES.bookProgress(bookId), { method: 'GET' }, getToken, doRefresh),

  markStudied: (sectionId: string, { getToken, doRefresh }: Auth) =>
    authedJson<SectionProgress>(
      API_ROUTES.markStudied(sectionId),
      { method: 'POST', body: JSON.stringify({ tzOffsetMinutes: tzOffsetMinutes() }) },
      getToken,
      doRefresh,
    ),

  recordSession: (
    sectionId: string,
    results: { cardId: string; result: CardResult }[],
    { getToken, doRefresh }: Auth,
  ) =>
    authedJson<RecordSessionResponse>(
      API_ROUTES.recordSession(sectionId),
      { method: 'POST', body: JSON.stringify({ results, tzOffsetMinutes: tzOffsetMinutes() }) },
      getToken,
      doRefresh,
    ),

  due: (languageCode: string, limit: number | undefined, { getToken, doRefresh }: Auth) =>
    authedJson<DueDeck>(API_ROUTES.due(languageCode, limit), { method: 'GET' }, getToken, doRefresh),

  /**
   * Posts a session whose cards may span sections. The server resolves each
   * card's section itself, which is what lets one run mix chapters or books.
   */
  recordReviewSession: (
    results: { cardId: string; result: CardResult }[],
    { getToken, doRefresh }: Auth,
  ) =>
    authedJson<RecordReviewSessionResponse>(
      API_ROUTES.recordReviewSession,
      { method: 'POST', body: JSON.stringify({ results, tzOffsetMinutes: tzOffsetMinutes() }) },
      getToken,
      doRefresh,
    ),
};
